import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Currency } from '@rx-applications/shared/data-access';

import { CurrencyState } from './currency.reducer';

export const STORE_NAME = 'Currency';

const currencyState = createFeatureSelector<CurrencyState>(STORE_NAME);

export const selectCurrencyObjectByCode = (props: { code: string }) =>
  createSelector(currencyState, (state: CurrencyState) => state.currencies.find((currency) => currency.code === props.code));

export const selectCurrenciesListLoaded = createSelector(
  currencyState,
  (state: CurrencyState) => state.currencies.length > 0
);

export const selectList = createSelector(currencyState, (state: CurrencyState) => state.currencies);

export const selectLoading = createSelector(currencyState, (state: CurrencyState) => state.loading);

export const currencySelectOptions = createSelector(selectList, (currencyList: Currency[]) =>
  currencyList.map((currency: Currency) => ({
    label: getCurrencyLabel(currency),
    value: currency.code,
  }))
);

function getCurrencyLabel(currency: Currency): string {
  // Workaround: API returns "&#8364;" instead of €
  const symbol = currency.symbol === '&#8364;' ? '€' : currency.symbol;
  return `${currency.code} (${symbol})`;
}
